import React, { FC } from 'react';
import AdvancedDailyEngagedUserConsumptionComponent from './AdvancedDailyEngagedUserConsumption';

const AdvancedDailyEngagedUserConsumption: FC = () => {
  return <AdvancedDailyEngagedUserConsumptionComponent />;
};

export default AdvancedDailyEngagedUserConsumption;